module.exports = __webpack_public_path__ + "62875dacaa3c20676f2351351a4c5b78.glb";